module.exports = __webpack_public_path__ + "img/product08-CRM.e3d15067.svg";